import Axios from "axios";
import { message } from "antd";

export default function deleteCompany(_id, cb) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "DELETE",
      url: `${process.env.REACT_APP_BASE_URL}/delete-reqCompany/${_id}`,
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        cb(_id);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
        message.error("Something Went Wrong Please try again Later");
      });
  };
}
